module.exports = __webpack_public_path__ + "img/exit-stair-area.4a580cbc.svg";